import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppNcdGestion = Loadable(lazy(() => import('./view/NcdGestion')))
const AppNcdRegistro = Loadable(lazy(() => import('./view/NcdRegistro')))

export const ncdRouteMap = {
  gestion: {
    path: '/ncd/gestion',
    name: 'Gestion de Notas',
  },
  nuevo: {
    path: '/ncd/nuevo',
    name: 'Nueva Nota',
  },
  modificar: {
    path: `/ncd/modificar`,
    name: 'Edita Nota',
  },
}

const notaCreditoDebitoRoutes = [
  {
    path: ncdRouteMap.gestion.path,
    element: <AppNcdGestion />,
    auth: authRoles.admin,
  },
  {
    path: ncdRouteMap.nuevo.path,
    element: <AppNcdRegistro />,
    auth: authRoles.admin,
  },
]

export default notaCreditoDebitoRoutes
